import React, { ComponentType } from 'react'

console.log('Vite ⚡️ Rails')
console.log('Build ✓')

import { createRoot } from 'react-dom/client'
import EntryFormSlideApp from '@/components/EntryFormSlideApp'
import KantoSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/kanto/sp/KantoSpLandingPage'
import KansaiSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/kansai/sp/KansaiSpLandingPage'
import InstagramAllRegionFormPage from '@/components/lp/foodslabo/instagram/area/allRegion/sp'
import TiktokAllRegionFormPage from '@/components/lp/foodslabo/tiktok/area/allRegion/sp'
import FormPage from '@/components/lp/foodslabo/googleAd/shared/forms/FormPage/index'
import NagoyaSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/nagoya/sp/NagoyaSpLandingPage'
import fukuokaSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/fukuoka/sp/FukuokaSpLandingPage'
import ZenkokuSpLandingPage from '@/components/lp/foodslabo/yahoo/areas/zenkoku/sp/ZenkokuSpLandingPage'
import SendaiSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/sendai/sp/SendaiSpLandingPage'
import NorthernKantoSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/northern_kanto/sp/NorthernKantoSpLandingPage'
import ShizuokaSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/shizuoka/sp/ShizuokaSpLandingPage'
import SapporoSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/sapporo/sp/SapporoSpLandingPage'
import HiroshimaSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/hiroshima/sp/HiroshimaSpLandingPage'
import NaganoSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/nagano/sp/NaganoSpLandingPage'
import NagasakiSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/nagasaki/sp/NagasakiSpLandingPage'
import OkinawaSpLandingPage from '@/components/lp/foodslabo/googleAd/areas/okinawa/sp/OkinawaSpLandingPage'
import InstagramKantoFormPage from '@/components/lp/foodslabo/instagram/area/kanto/sp'
import InstagramKansaiFormPage from '@/components/lp/foodslabo/instagram/area/kansai/sp'
import InstagramNaganoFormPage from '@/components/lp/foodslabo/instagram/area/nagano/sp'
import InstagramNagasakiFormPage from '@/components/lp/foodslabo/instagram/area/nagasaki/sp'
import InstagramOkinawaFormPage from '@/components/lp/foodslabo/instagram/area/okinawa/sp'
import GenieeZenkokuSpLandingPage from '@/components/lp/foodslabo/geniee/areas/zenkoku/sp/ZenkokuSpLandingPage'
import AllSpLandingPage from '@/components/lp/foodslabo/all/areas/zenkoku/sp/AllSpLandingPage'
import ThanksPage from '@/components/lp/foodslabo/thanks/ThanksPage'

type Prefecture = [displayName: string, prefectureName: string]

interface ComponentProps {
    prefectures: Prefecture[]
}

interface ComponentMapping {
    containerId: string
    component: ComponentType<ComponentProps>
}


const componentMappings: ComponentMapping[] = [
    {
        containerId: 'all-sp-landing-page',
        component: AllSpLandingPage
    },
    {
        containerId: 'entry-form-slide-app',
        component: EntryFormSlideApp
    },
    {
        containerId: 'instagram-column-renewal-entry-form',
        component: InstagramAllRegionFormPage
    },
    {
        containerId: 'instagram-column_lp',
        component: InstagramKantoFormPage
    },
    {
        containerId: 'instagram-column_lp_ks',
        component: InstagramKansaiFormPage
    },
    {
        containerId: 'instagram-column_lp_nagano',
        component: InstagramNaganoFormPage
    },
    {
        containerId: 'instagram-column_lp_nagasaki',
        component: InstagramNagasakiFormPage
    },
    {
        containerId: 'instagram-column_lp_okinawa',
        component: InstagramOkinawaFormPage
    },
    {
        containerId: 'google-ad-kanto-sp-landing-page',
        component: KantoSpLandingPage
    },
    {
        containerId: 'google-ad-fukuoka-sp-landing-page',
        component: fukuokaSpLandingPage
    },
    {
        containerId: 'google-ad-kansai-sp-landing-page',
        component: KansaiSpLandingPage
    },
    {
        containerId: 'google-ad-nagoya-sp-landing-page',
        component: NagoyaSpLandingPage
    },
    {
        containerId: 'yahoo-zenkoku-sp-landing-page',
        component: ZenkokuSpLandingPage
    },
    {
        containerId: 'google-ad-sendai-sp-landing-page',
        component: SendaiSpLandingPage
    },
    {
        containerId: 'google-ad-northern_kanto-sp-landing-page',
        component: NorthernKantoSpLandingPage
    },
    {
        containerId: 'google-ad-shizuoka-sp-landing-page',
        component: ShizuokaSpLandingPage
    },
    {
        containerId: 'google-ad-sapporo-sp-landing-page',
        component: SapporoSpLandingPage
    },
    {
        containerId: 'google-ad-hiroshima-sp-landing-page',
        component: HiroshimaSpLandingPage
    },
    {
        containerId: 'google-ad-hiroshima-lp-sp-landing-page',
        component: HiroshimaSpLandingPage
    },
    {
        containerId: 'google-ad-nagano-sp-landing-page',
        component: NaganoSpLandingPage
    },
    {
        containerId: 'google-ad-nagasaki-sp-landing-page',
        component: NagasakiSpLandingPage
    },
    {
        containerId: 'google-ad-okinawa-sp-landing-page',
        component: OkinawaSpLandingPage
    },
    {
        containerId: 'geniee-zenkoku-sp-landing-page',
        component: GenieeZenkokuSpLandingPage
    },
    {
        containerId: 'tiktok-column-entry-form',
        component: TiktokAllRegionFormPage
    },
    {
        containerId: 'register-form',
        component: FormPage
    }
]

const renderComponent = (containerId: string, Component: ComponentType<ComponentProps>): void => {
    const container = document.getElementById(containerId)
    if (container) {
        try {
            const prefecturesData = container.dataset.prefectures ? JSON.parse(container.dataset.prefectures) : []
            const root = createRoot(container)
            root.render(<Component prefectures={prefecturesData} />)
        } catch (error) {
            console.error(`Failed to render component for container ${containerId}:`, error)
        }
    }
}

const renderThanksPage = (): void => {
    const container = document.getElementById('foodslabo-thanks-page')
    if (container) {
        const jobSeekerData = container.dataset.jobSeeker
        const urlParams = new URLSearchParams(window.location.search)
        const locationFromUrl = urlParams.get('location')
        const locationFromData = container.dataset.location || ''
        const location = locationFromUrl || locationFromData || 'kanto'
        const jobSeeker = jobSeekerData ? JSON.parse(jobSeekerData) : undefined
        const root = createRoot(container)
        root.render(<ThanksPage jobSeeker={jobSeeker} location={location} />)
    }
}

document.addEventListener('DOMContentLoaded', () => {

    renderThanksPage()

    componentMappings.forEach(({ containerId, component }) => {
        renderComponent(containerId, component)
    })
})
